import API from "@/services/api/api.service";
import stateStore from "@/utils/store";
import { RouteLocationNormalized } from "vue-router";

export const logoutResolver = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    try {
        await API.logout();
        stateStore.logout();
        return { name: 'Login' };
    } catch(error) {
        stateStore.logout();
        return { name: 'Login' };
    }
}